import React from "react";
import { useNotify, useRecordContext } from "react-admin";
import Button from "@mui/material/Button";
import { API_ROOT } from "transport-layer/src";
import CircularProgress from "@mui/material/CircularProgress";
import { templateSettings, template } from "lodash";
import { styled } from '@mui/system';

templateSettings.interpolate = /{{([\s\S]+?)}}/g;

const StyledButton = styled(Button)({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '200px', // Adjust this value as needed
  display: 'block',
  '&:hover': {
    // overflow: 'auto',
    textOverflow: 'unset',
  },
  '&::-webkit-scrollbar': {
    height: '8px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#888',
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
});

const ExcelReportButton = (props) => {
  const record = useRecordContext()
  const [ downloadingStatus, setDownloadingStatus] = React.useState(false);
  const notify = useNotify();
  const downloadReport = (outfilename, reportConfig) => {
    
    const token = localStorage.getItem("token");

    fetch(`${API_ROOT}/utils/excel`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: reportConfig,
    })
      .then((response) => {
        if (response.ok) {
          return response.arrayBuffer();
        } else if (response.status === 404) {
          notify("No data available: this report did not return any results.", "info");
        } else {
          throw new Error("Something went wrong");
        }
      })
      .then((buffer) => {
        if (buffer) {
          var blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `${outfilename}.xlsx`;
          link.click();
          notify("Report Ready", "info");
        }
        
      })
      .catch((err) => {
        notify("Report Error: Please contact support", "warning");
      })
      .finally(() => {
        setDownloadingStatus(false);
        
      });
  };

  return (
    <StyledButton
      color={props.is_draft ? "secondary" : "primary"}
      size="small"
      style={{
        marginBottom: "0.5em",
        marginTop: "0.5em",
      }}
      onClick={(x) => {
        setDownloadingStatus(true);

        const compiled = template(JSON.stringify(props.excel_configuration));      
        const reportConfig = compiled({
          ...record,
          [props.filter_field]: props.filter_by,
        });
        
        const OutfileName = JSON.parse(reportConfig).OutFileName;

        downloadReport(OutfileName, reportConfig);
      }}
    >
      <React.Fragment>
        {props.name}
        {downloadingStatus && (
          <CircularProgress size={15} style={{ marginLeft: 7 }} />
        )}
      </React.Fragment>
    </StyledButton>
  );
};
export default ExcelReportButton;
